import { render, staticRenderFns } from "./License.vue?vue&type=template&id=6b9e10e6&scoped=true"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"
import style0 from "./License.vue?vue&type=style&index=0&id=6b9e10e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9e10e6",
  null
  
)

export default component.exports